if (!customElements.get('c2o3-pill-carousel')) {
  customElements.define('c2o3-pill-carousel', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-pill-viewport]');
      this.track = this.querySelector('[data-pill-track]');
      this.previous = this.querySelector('[data-pill-previous]');
      this.next = this.querySelector('[data-pill-next]');
      if (!this.viewport || !this.track || !this.previous || !this.next) return;

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this);
      this.observer.observe(this.viewport);
      this.observer.observe(this.track);
      this.schedule();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      const scrolling = getComputedStyle(this.viewport).overflowX === 'auto';
      this.dataset.overflow = String(scrolling && this.track.scrollWidth > this.clientWidth + 1);
      const position = Math.abs(this.viewport.scrollLeft);
      const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= maximum - 1;
    }

    move(direction) {
      const rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.viewport.scrollBy({
        left: direction * (rtl ? -1 : 1) * this.viewport.clientWidth * 0.8,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }
  });
}
